import { Component, Inject, Input } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { EntityCheckboxListComponent } from '../../../../shared/checkbox-list/components/entity-checkbox-list.component';

import { SousParcService } from '../services/sous-parc.service';
import { SousParcTLR } from '../entities/sous-parc-tlr.entity';

@Component({
	selector: 'sous-parc-checkbox-list',
	templateUrl: '../../../../shared/checkbox-list/components/entity-checkbox-list.html',
	styleUrls: ['../../../../shared/checkbox-list/components/entity-checkbox-list.css']
})
export class SousParcCheckboxListComponent extends EntityCheckboxListComponent<SousParcTLR> {
	// Ids des parcs dont les ouvrages doivent etre affiches comme options
	_parcIds: number[] = [];
	@Input() set parcIds(ids: number[] | undefined) {
		if (ids != undefined && ids != this._parcIds) {
			this._parcIds = ids;
			this.updateSousParcs();
		}
	}
	
	// Label du champ
	override label = "Sous-parc(s)"
	
	// Fonction determinant le label d'un sous-parc
	override getEntityLabel = (sousParc: SousParcTLR) => sousParc.code + " (" + sousParc.description + ")"
	
	// Observable des sous-parcs qu'il faut selectionne sur commande du parent
	@Input() set sousParcSelectionRequests(obs: Observable<number>) {
		this.selectionsSubject = obs.pipe(
			map (
				(sousParcId) => (item: SousParcTLR) => item.id === sousParcId
			)
		)
	}

	constructor( //
		@Inject(SousParcService) private sousParcService: SousParcService //
	) {
		super();
	}
	
	private updateSousParcs() {
		if (this._parcIds && this._parcIds.length > 0) {
			this.sousParcService.getSousParcTLRMapByParc().subscribe(
				(map: Map<number, SousParcTLR[]>) => {
					let sousParcs: SousParcTLR[] = [];
					for (let i = 0; i <= this._parcIds.length; i++) {
						let parcId = this._parcIds[i];
						let list = map.get(parcId);
						if (list) {
							sousParcs = sousParcs.concat(list);
						}
					}
					
					// Trier ensuite tous les sous-parc par leur code
					sousParcs.sort(
						(sp1, sp2) => sp1.code.localeCompare(sp2.code) 
					);

					this.entities = sousParcs;
				}
			);
		} else {
			this.entities = [];
		}
	}
}